import { useEffect, useRef, useState } from "react";
import { ColorPickerOverlay } from "./ColorPickerOverlay";
import Input from "./Input";
import Text from "./Text";
import { OverlayPanel } from "primereact/overlaypanel";

interface Props {
  className?: string;
  inputClassName?: string;
  label?: string;
  labelWidth?: string | number;
  name?: string;
  defaultValue?: string;
  onChange?: (color: string) => void;
}

export default function ColorInputField({
  className,
  inputClassName,
  label,
  labelWidth,
  name,
  defaultValue,
  onChange,
}: Props) {
  const opRef = useRef<OverlayPanel>(null);
  const [color, setColor] = useState("#fff");

  useEffect(() => {
    setColor(defaultValue || "#fff");
  }, [defaultValue]);

  const onChangeColor = (newColor: string) => {
    newColor = newColor.trim();
    onChange?.(newColor);
    setColor(newColor);
  };

  return (
    <>
      <div className={`flex items-center gap-2 ${className}`}>
        {label && (
          <Text text={label} width={labelWidth} size="medium" weight="medium" />
        )}
        <Input
          className={`w-full text-white ${inputClassName}`}
          name={name}
          type="text"
          value={color}
          style={{ backgroundColor: color }}
          onChange={(event) => onChangeColor(event.target.value)}
          onClick={(event) => opRef.current?.toggle(event)}
        />
      </div>
      <ColorPickerOverlay
        ref={opRef}
        color={color}
        onChange={onChangeColor}
      />
    </>
  );
}
